import { render, staticRenderFns } from "./doctors-list.vue?vue&type=template&id=eb6a7514"
import script from "./doctors-list.vue?vue&type=script&lang=js"
export * from "./doctors-list.vue?vue&type=script&lang=js"
import style0 from "./doctors-list.vue?vue&type=style&index=0&id=eb6a7514&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports